import React, { useEffect, useState } from 'react';
import { LEGAL } from './legalConfig';

const read = () => {
  try { const v = JSON.parse(localStorage.getItem(LEGAL.cookieStorageKey) || 'null');
    return v && v.version === LEGAL.cookieVersion ? v : null; } catch { return null; }
};
/** true only if the user opted in to that category (essential is always true). */
export const hasCookieConsent = (category) => category === 'essential' || !!(read() || {})[category];
/** Call from a footer "Cookie settings" link to re-open the banner. */
export const openCookieSettings = () => window.dispatchEvent(new Event('open-cookie-settings'));

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!read()) setOpen(true);
    const h = () => setOpen(true);
    window.addEventListener('open-cookie-settings', h);
    return () => window.removeEventListener('open-cookie-settings', h);
  }, []);
  if (!open) return null;
  const save = (all) => {
    localStorage.setItem(LEGAL.cookieStorageKey, JSON.stringify({
      version: LEGAL.cookieVersion, essential: true, analytics: !!all, decided_at: new Date().toISOString(),
    }));
    setOpen(false);
    // index.html defines window.__loadAnalytics; it only runs after an opt-in.
    if (all && typeof window.__loadAnalytics === 'function') window.__loadAnalytics();
  };
  const btn = { flex: 1, padding: '8px 12px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' };
  return (
    <div role="region" aria-label="Cookie consent" data-testid="cookie-banner"
      style={{ position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 9999, maxWidth: 640, margin: '0 auto',
        background: '#fff', color: '#111', borderRadius: 12, boxShadow: '0 8px 30px rgba(0,0,0,.25)', padding: 16 }}>
      <p style={{ fontSize: 13, marginBottom: 12 }}>
        We use strictly necessary cookies to sign you in and keep {LEGAL.appName} secure.{' '}
        {LEGAL.hasNonEssentialCookies
          ? "With your permission we'd also use analytics cookies to improve the app."
          : "We don't use advertising or tracking cookies."}{' '}
        <a href={LEGAL.routes.cookies} style={{ textDecoration: 'underline' }}>Cookie Policy</a>
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" data-testid="cookie-reject" onClick={() => save(false)}
          style={{ ...btn, border: '1px solid #111827', background: '#fff', color: '#111827' }}>
          {LEGAL.hasNonEssentialCookies ? 'Reject non-essential' : 'Essential only'}
        </button>
        <button type="button" data-testid="cookie-accept" onClick={() => save(true)}
          style={{ ...btn, border: '1px solid #111827', background: '#111827', color: '#fff' }}>
          {LEGAL.hasNonEssentialCookies ? 'Accept all' : 'OK'}
        </button>
      </div>
    </div>
  );
}
